import type { Selector } from 'reselect';
import { createSelector } from 'reselect';

import createAssetSourceActivityByIdSelector from './create-asset-source-activity-by-id.js';
import type { ActivityItem } from '../types.js';

type CreateActivityItemSelectorParams = {
  assetName: string;
  walletAccount: string;
  id: string;
};

const createActivityItemSelector = ({
  assetName,
  walletAccount,
  id,
}: CreateActivityItemSelectorParams): Selector<
  unknown,
  ActivityItem | undefined
> =>
  createSelector(
    createAssetSourceActivityByIdSelector({ assetName, walletAccount }),
    (activityById) => activityById[id],
  );

export default createActivityItemSelector;
